import React, { useState, useCallback, useRef, useEffect } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import classes from "./EditPhoto.module.css";
import { Button } from "../../../../../stories/Button/Button";
import { Row, Col } from "react-bootstrap";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import {
  ChakraProvider,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
} from "@chakra-ui/react";
import {
  AddIconBlue,
  RangeSliderIcon,
  RotateIconBlue,
} from "../../../../../constant/imagePath";
import Cropper from "react-easy-crop";
import getCroppedImg from "./CreateImage";

export default function EditPhotoModal({
  show,
  setShow,
  state,
  setter,
  onSave,
  onChangeImage,
}) {
  const [image, setImage] = useState(URL.createObjectURL(state));
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotate, setRotate] = useState(0);

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      try {
        const newImage = await getCroppedImg(image, croppedAreaPixels, rotate);
        console.log("donee", { newImage });
        setCroppedImage(newImage);
      } catch (e) {
        console.error(e);
      }
    },
    [rotate]
  );

  const HandleSetRotate = () => {
    if (rotate === 270) {
      setRotate(0);
    } else {
      setRotate(rotate + 90);
    }
  };
  console.log({ zoom });

  return (
    <>
      <style>{`

      .modal-footer{
        margin-top:32px !important;

      }
        .reactEasyCrop_CropAreaGrid::before {
          border: none;
        }
        .reactEasyCrop_CropAreaGrid::after {
          border: none;
        }
        .reactEasyCrop_CropArea {
          border-radius: 16px;
          width: 40% !important;
          height: 95% !important;
          color: #222222;
          opacity: 0.8;

        }
        .crop-container {
          position: absolute;
          top: 0;
          left: 3%;
          right: 0;
          bottom: 80px;
          width: 50%;
          height: 75%;
          border-radius: 16px;
          overflow: hidden;
        }
        @media screen and (min-width: 2321px) {
          .modal .modal-dialog{
            max-width: 32.5% !important;
          }
        }
        @media screen and (min-width: 2171px) and (max-width: 2320px) {
          .modal .modal-dialog{
            max-width: 35% !important;
          }
        }
        @media screen and (min-width: 2000px) and (max-width: 2170px) {
          .modal .modal-dialog{
            max-width: 38% !important;
          }
        }
        @media screen and (min-width: 1801px) and (max-width: 1999px) {
          .modal .modal-dialog{
            max-width: 42% !important;
          }
        }
        @media screen and (min-width: 1651px) and (max-width: 1800px) {
          .modal .modal-dialog{
            max-width: 45% !important;
          }
        }
        @media screen and (min-width: 1531px) and (max-width: 1650px) {
          .modal .modal-dialog{
            max-width: 50% !important;
          }
        }
        @media screen and (min-width: 1441px) and (max-width: 1530px) {
          .modal .modal-dialog{
            max-width: 52% !important;
          }
        }
        @media screen and (min-width: 1381px) and (max-width: 1440px) {
          .modal .modal-dialog{
            max-width: 55% !important;
          }
        }
        @media screen and (min-width: 1301px) and (max-width: 1380px) {
          .modal .modal-dialog{
            max-width: 60% !important;
          }
        }
        @media screen and (min-width: 1191px) and (max-width: 1300px) {
          .modal .modal-dialog{
            max-width: 65% !important;
          }
        }
        @media screen and (min-width: 1101px) and (max-width: 1190px) {
          .modal .modal-dialog{
            max-width: 70% !important;
          }
        }
        @media screen and (min-width: 1025px) and (max-width: 1100px) {
          .modal .modal-dialog{
            max-width: 75% !important;
          }
        }
        @media screen and (min-width: 991px) and (max-width: 1024px) {
          .modal .modal-dialog{
            max-width: 80% !important;
          }
        }
        @media screen and (min-width: 901px) and (max-width: 990px) {
          .modal .modal-dialog{
            max-width: 85% !important;
          }
        }
        @media screen and (min-width: 851px) and (max-width: 900px) {
          .modal .modal-dialog{
            max-width: 90% !important;
          }
        }
        @media screen and (min-width: 801px) and (max-width: 850px) {
          .modal .modal-dialog{
            max-width: 95% !important;
          }
        }
        @media screen and (min-width: 769px) and (max-width: 800px) {
          .modal .modal-dialog{
            max-width: 100% !important;
          }
        }
        @media screen and (min-width: 769px) and (max-width: 800px) {
          .modal .modal-dialog{
            max-width: 100% !important;
          }
        }
        .chakra-slider__thumb:focus{
          box-shadow:none !important;
        }

`}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "0px", margin: "0px" }}
        width={"40%"}
        header={
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Edit photo
          </h4>
        }
        footer={
          <div className={classes.footerBtns}>
            <LinkButtonWithIcon
              text={"Change image"}
              primary={false}
              customStyle={{
                marginRight: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
              onClick={() => setShow(false)}
            />
            <Button
              label={"Save"}
              primary={true}
              size={"Medium"}
              customStyle={{
                width: "120px",
                height: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={() => {
                onSave(croppedImage);
                setShow(false);
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <Row>
            <Col md={6}>
              <div className={classes.leftContainer}>
                <div className="crop-container">
                  <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    rotation={rotate}
                    aspect={4 / 3}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                    style={{ containerStyle: { maxHeight: "400px" } }}
                  />
                </div>
                <div className={classes.rangeWithBtns}>
                  <span style={{ marginRight: zoom == 1 ? "12px" : "0px" }}>
                    <LinkButtonWithIcon
                      leftIcon={AddIconBlue}
                      text={"Zoom"}
                      primary={true}
                      customStyle={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                        ...Fonts.otherMedium,
                      }}
                      iconStyle={{ margin: "0px" }}
                      disabled={zoom == 1 ? true : false}
                      onClick={() => setZoom((prev) => ++prev)}
                    />
                  </span>
                  <ChakraProvider>
                    <div className={`${[classes.rangePicker].join(" ")}`}>
                      <RangeSlider
                        aria-label={["min", "max"]}
                        onChange={(e) => {
                          setZoom(e[0]);
                        }}
                        value={[zoom, 1.5]}
                        min={1}
                        max={1.5}
                        step={0.05}
                      >
                        <RangeSliderTrack bg={Colors.neutralShadesOfWhisper}>
                          <RangeSliderFilledTrack
                            bg={Colors.neutralShadesOfGainsboro}
                          />
                        </RangeSliderTrack>

                        <RangeSliderThumb
                          boxSize={6}
                          index={0}
                          style={{
                            backgroundColor: "none",
                            background: `url(${RangeSliderIcon}) no-repeat`,
                            border: "none",
                            borderRadius: 0,
                            display: "flex",
                            "&:focus": {
                              boxShadow: "none",
                            },
                          }}
                        ></RangeSliderThumb>
                        <RangeSliderThumb
                          boxSize={6}
                          index={1}
                          style={{
                            backgroundColor: "none",
                            background: `url(${RangeSliderIcon})`,
                            border: "none",
                            borderRadius: 0,
                            display: "none",
                          }}
                        ></RangeSliderThumb>
                      </RangeSlider>
                    </div>
                  </ChakraProvider>
                  <span>
                    <LinkButtonWithIcon
                      leftIcon={RotateIconBlue}
                      text={"Rotate"}
                      primary={true}
                      customStyle={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                        ...Fonts.otherMedium,
                      }}
                      iconStyle={{
                        margin: "0px",
                      }}
                      onClick={() => {
                        HandleSetRotate();
                      }}
                    />
                  </span>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className={classes.rightContainer}>
                <div className={classes.imagesRow}>
                  <div className={classes.col2}>
                    <img
                      src={croppedImage}
                      className={classes.borderRadiusimage}
                    />
                  </div>
                  <div className={classes.col3}>
                    <img
                      src={croppedImage}
                      className={classes.borderRadiusimage}
                    />
                  </div>
                  <div className={classes.col4}>
                    <img
                      src={croppedImage}
                      className={classes.borderRadiusimage}
                    />
                  </div>
                </div>

                <div className={classes.headingWithDescription}>
                  <h6
                    style={{
                      ...Fonts.h9,
                      letterSpacing: "-1%",
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    Must be an actual photo of you.
                  </h6>
                  <p
                    style={{
                      ...Fonts.p2,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    Logos, clip-art, group photos, and digitally-altered images
                    are not allowed
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </ModalSkeleton>
    </>
  );
}
